"use client"

import { GalleryItem } from "@/components/Gallery/item"
import { Maybe, ProductInterface } from "@/types/graphql.prod"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { useEffect, useState } from "react"
import { CarouselApi } from "@/components/ui/carousel-pro"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel"

const ProductsSlider = ({
  crossData,
}: {
  crossData: Maybe<ProductInterface>[]
}) => {
  const [api, setApi] = useState<CarouselApi | null>(null)
  const [scrollProgress, setScrollProgress] = useState(0)

  useEffect(() => {
    if (!api) {
      return
    }

    const onScroll = () => {
      const progress = Math.max(0, Math.min(1, api.scrollProgress()))
      setScrollProgress(progress * 100)
    }

    onScroll()
    api.on("reInit", onScroll)
    api.on("scroll", onScroll)

    return () => {
      api.off("scroll", onScroll)
      api.off("reInit", onScroll)
    }
  }, [api])

  return (
    <div className=" w-full pb-[30px]">
      <Carousel
        setApi={setApi}
        opts={{
          align: "start",
          loop: false,
          skipSnaps: false,
          dragFree: true,
        }}
        className="cursor-grab"
      >
        <CarouselContent className="-ml-[22px]">
          {crossData.map((product, index) => {
            if (product) {
              return (
                <CarouselItem key={product.uid} className="basis-1/2 pl-[22px]">
                  <GalleryItem item={product} showCustomizeOptions={false} />
                </CarouselItem>
              )
            }
          })}
        </CarouselContent>
      </Carousel>
      <div className="relative mt-6 h-1 rounded-[4px] bg-[#e2e9e2] lg_mt-10">
        <div
          className="absolute top-0 h-full w-[16%] rounded-[4px] bg-primary "
          style={{
            left: `${scrollProgress * 0.84}%`,
          }}
        ></div>
      </div>
    </div>
  )
}

export default ProductsSlider
